/**
 * La veine d'onyx d'un passeport (RDEC-025). Elle se déduit du seul Provena
 * ID : tout support (le site, un PDF, un objet) retrouve la même veine en
 * suivant la recette ci-dessous. C'est un ornement : calculée depuis un
 * identifiant public, elle ne prouve rien et ne doit jamais être présentée
 * comme une empreinte ou une garantie.
 *
 * Recette : FNV-1a 32 bits sur l'identifiant (espaces retirés, en
 * majuscules) ; graine = h mod 2147483645 + 1 ; bruit SVG `feTurbulence` de
 * type turbulence, fréquences 0,0035 × 0,011, 4 octaves, tuile de 800 px.
 */

// Au sommet d'une veine, le gris le plus pâle doit encore tenir 4,5:1
// (palette.test.js le vérifie avec le reflet de .passport-onyx).
export const VEINE_OPACITE_MAX = 0.1;

export const graineOnyx = (provenaId) => {
  const texte = String(provenaId ?? "").trim().toUpperCase();
  let h = 0x811c9dc5;
  for (let i = 0; i < texte.length; i += 1) {
    h ^= texte.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return ((h >>> 0) % 2147483645) + 1;
};

export const veineOnyx = (provenaId) =>
  `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='800' height='800'%3E` +
  `%3Cfilter id='v'%3E%3CfeTurbulence type='turbulence' baseFrequency='0.0035 0.011' numOctaves='4' ` +
  `seed='${graineOnyx(provenaId)}' stitchTiles='stitch'/%3E` +
  `%3CfeColorMatrix values='0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  0 0 0 ${VEINE_OPACITE_MAX} 0'/%3E%3C/filter%3E` +
  `%3Crect width='100%25' height='100%25' filter='url(%23v)'/%3E%3C/svg%3E")`;
